import { createSelector } from '@opengov/compose-app/reselect';
import { effectSelector } from './effectState';
export var selectQueuedEffects = createSelector(effectSelector, function (state) {
  return state.queued;
});
export var selectAll = function selectAll(state) {
  return state;
};
export var selectEffectSubscriberProps = createSelector(selectQueuedEffects, selectAll, function (queuedEffects, state) {
  return {
    queuedEffects: queuedEffects,
    state: state
  };
});